import script from "./DramaInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DramaInfo.vue?vue&type=script&setup=true&lang=js"

import "./DramaInfo.vue?vue&type=style&index=0&id=02776dc4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02776dc4"]])

export default __exports__